// src/constants/permisos.js
export const FEATURE_BITS = {
  // ====== VENTANAS (VIEW) 1..11 ======
  INICIO_VIEW: 1,
  ESTANQUES_VIEW: 2,
  DISPOSITIVOS_VIEW: 3,
  SENSORES_VIEW: 4,
  EFECTORES_VIEW: 5,
  ALARMAS_VIEW: 6,
  AUTOMATIZACION_VIEW: 7,
  USUARIOS_TEMP_VIEW: 8,
  REPORTERIA_VIEW: 9,
  CONFIGURACIONES_VIEW: 10,
  ACERCA_VIEW: 11,

  // ====== VENTANAS (EDIT) 12..22 ======
  INICIO_EDIT: 12,
  ESTANQUES_EDIT: 13,
  DISPOSITIVOS_EDIT: 14,
  SENSORES_EDIT: 15,
  EFECTORES_EDIT: 16,
  ALARMAS_EDIT: 17,
  AUTOMATIZACION_EDIT: 18,
  USUARIOS_TEMP_EDIT: 19,
  REPORTERIA_EDIT: 20,
  CONFIGURACIONES_EDIT: 21,
  ACERCA_EDIT: 22,

  // ====== PESTAÑAS (VIEW/EDIT) ======
  // Estanques
  ESTANQUES_TAB_CREAR_VIEW: 23,
  ESTANQUES_TAB_CREAR_EDIT: 24,
  ESTANQUES_TAB_EDITAR_VIEW: 25,
  ESTANQUES_TAB_EDITAR_EDIT: 26,

  // Dispositivos
  DISPOSITIVOS_TAB_CREAR_VIEW: 27,
  DISPOSITIVOS_TAB_CREAR_EDIT: 28,
  DISPOSITIVOS_TAB_EDITAR_VIEW: 29,
  DISPOSITIVOS_TAB_EDITAR_EDIT: 30,

  // Sensores
  SENSORES_TAB_CREAR_VIEW: 31,
  SENSORES_TAB_CREAR_EDIT: 32,
  SENSORES_TAB_EDITAR_VIEW: 33,
  SENSORES_TAB_EDITAR_EDIT: 34,

  // Efectores
  EFECTORES_TAB_CREAR_VIEW: 35,
  EFECTORES_TAB_CREAR_EDIT: 36,
  EFECTORES_TAB_EDITAR_VIEW: 37,
  EFECTORES_TAB_EDITAR_EDIT: 38,

  // Automatización
  AUTOMATIZACION_TAB_SENSORES_VIEW: 39,
  AUTOMATIZACION_TAB_SENSORES_EDIT: 40,
  AUTOMATIZACION_TAB_EFECTORES_VIEW: 41,
  AUTOMATIZACION_TAB_EFECTORES_EDIT: 42,

  // Usuarios temporales
  USUARIOS_TEMP_TAB_CREAR_VIEW: 43,
  USUARIOS_TEMP_TAB_CREAR_EDIT: 44,
  USUARIOS_TEMP_TAB_EDITAR_VIEW: 45,
  USUARIOS_TEMP_TAB_EDITAR_EDIT: 46,

  // ====== LISTAS / REPORTERÍA ======
  ESTANQUES_TAB_LISTA_VIEW: 47,
  ESTANQUES_TAB_LISTA_EDIT: 48,
  DISPOSITIVOS_TAB_LISTA_VIEW: 49,
  DISPOSITIVOS_TAB_LISTA_EDIT: 50,
  SENSORES_TAB_LISTA_VIEW: 51,
  SENSORES_TAB_LISTA_EDIT: 52,
  EFECTORES_TAB_LISTA_VIEW: 53,
  EFECTORES_TAB_LISTA_EDIT: 54,
  USUARIOS_TEMP_TAB_LISTA_VIEW: 55,
  USUARIOS_TEMP_TAB_LISTA_EDIT: 56,

  // ====== CONFIGURACIONES (solo activas) ======
  CONFIGURACIONES_TAB_PERFIL_VIEW: 57,
  CONFIGURACIONES_TAB_PERFIL_EDIT: 58,

  // ====== Configuraciones → Parámetros (detallado) ======
  CONFIGURACIONES_TAB_PARAMETROS_VIEW: 59,
  CONFIGURACIONES_TAB_PARAMETROS_EDIT: 60,
  CONFIGURACIONES_PARAMETROS_LISTA_VIEW: 61,
  CONFIGURACIONES_PARAMETROS_LISTA_EDIT: 62,
  CONFIGURACIONES_PARAMETRO_EDITAR_VIEW: 63,
  CONFIGURACIONES_PARAMETRO_EDITAR_EDIT: 64,

  // ====== Configuraciones → Firmware (nuevo) ======
  CONFIGURACIONES_TAB_FIRMWARE_VIEW: 65,
  CONFIGURACIONES_TAB_FIRMWARE_EDIT: 66,
  FIRMWARE_TAB_FLASH_VIEW: 67,
  FIRMWARE_TAB_FLASH_EDIT: 68,
  FIRMWARE_TAB_CONFIG_VIEW: 69,
  FIRMWARE_TAB_CONFIG_EDIT: 70,
  FIRMWARE_TAB_OTA_VIEW: 71,
  FIRMWARE_TAB_OTA_EDIT: 72,

  // ====== INICIAL → pestañas de Inicio ======
  INICIO_TAB_BIENVENIDA_VIEW: 73,
  INICIO_TAB_BIENVENIDA_EDIT: 74,

  // 🔹 Inicio → Mis Sensores
  INICIO_TAB_MIS_SENSORES_VIEW: 75,
  INICIO_TAB_MIS_SENSORES_EDIT: 76,

  // 🔹 Inicio → Mis Estadísticas
  INICIO_TAB_MIS_ESTADISTICAS_VIEW: 77,
  INICIO_TAB_MIS_ESTADISTICAS_EDIT: 78,

  // ====== Configuraciones → Respaldo ======
  CONFIGURACIONES_TAB_RESPALDO_VIEW: 79,
  CONFIGURACIONES_TAB_RESPALDO_EDIT: 80,


  // ====== RESERVADOS 79..90 ======
  ALARMAS_TAB_CREAR_VIEW: 81,
  ALARMAS_TAB_CREAR_EDIT: 82,
  ALARMAS_TAB_ADMIN_VIEW: 83,
  ALARMAS_TAB_ADMIN_EDIT: 84,
  ALARMAS_TAB_HISTORIAL_VIEW: 85,
  ALARMAS_TAB_HISTORIAL_EDIT: 86,
  CONTACTO_VIEW: 87,
  RESERVED_88: 88,
  RESERVED_89: 89,
  RESERVED_90: 90,
  ESTANQUES_TAB_TABLERO_VIEW: 91,
  ESTANQUES_TAB_TABLERO_EDIT: 92,
  DISPOSITIVOS_TAB_TABLERO_VIEW: 93,
  DISPOSITIVOS_TAB_TABLERO_EDIT: 94,
  SENSORES_TAB_TABLERO_VIEW: 95,
  SENSORES_TAB_TABLERO_EDIT: 96,
  EFECTORES_TAB_TABLERO_VIEW: 97,
  EFECTORES_TAB_TABLERO_EDIT: 98,
  ALARMAS_TAB_TABLERO_VIEW: 99,
  ALARMAS_TAB_TABLERO_EDIT: 100,
  AUTOMATIZACION_TAB_TABLERO_VIEW: 101,
  AUTOMATIZACION_TAB_TABLERO_EDIT: 102,
  DISPOSITIVOS_TAB_ASISTENTE_VIEW: 103,
  DISPOSITIVOS_TAB_ASISTENTE_EDIT: 104,
  REPORTERIA_TAB_OPERACION_VIEW: 105,
  REPORTERIA_TAB_OPERACION_EDIT: 106,
  REPORTERIA_TAB_AUDITORIA_VIEW: 107,
  REPORTERIA_TAB_AUDITORIA_EDIT: 108,
  REPORTERIA_TAB_ALARMAS_VIEW: 109,
  REPORTERIA_TAB_ALARMAS_EDIT: 110,
  REPORTERIA_TAB_AUTOMATIZACION_VIEW: 111,
  REPORTERIA_TAB_AUTOMATIZACION_EDIT: 112,
  INICIO_TAB_RESUMEN_VIEW: 113,
  INICIO_TAB_RESUMEN_EDIT: 114,
  REPORTERIA_TAB_LECTURAS_VIEW: 115,
  REPORTERIA_TAB_LECTURAS_EDIT: 116,

};

// ✅ Alias directo
export const FEATURE = FEATURE_BITS;

export const FEATURE_KEYS_SORTED = Object.keys(FEATURE_BITS)
  .sort((a, b) => FEATURE_BITS[a] - FEATURE_BITS[b]);

export const BITSET_LEN = 116;

// Plantillas recomendadas. Son sólo el punto de partida: el propietario puede
// activar o desactivar cualquier permiso antes de guardar.
const CREATION_FEATURES = new Set([
  "ESTANQUES_TAB_CREAR_VIEW", "ESTANQUES_TAB_CREAR_EDIT",
  "DISPOSITIVOS_TAB_CREAR_VIEW", "DISPOSITIVOS_TAB_CREAR_EDIT",
  "SENSORES_TAB_CREAR_VIEW", "SENSORES_TAB_CREAR_EDIT",
  "EFECTORES_TAB_CREAR_VIEW", "EFECTORES_TAB_CREAR_EDIT",
  "ALARMAS_TAB_CREAR_VIEW", "ALARMAS_TAB_CREAR_EDIT",
  "USUARIOS_TEMP_TAB_CREAR_VIEW", "USUARIOS_TEMP_TAB_CREAR_EDIT",
]);

export const ROLE_DEFAULT_FEATURES = {
  // Puede administrar lo existente, pero las altas quedan desmarcadas.
  1: Object.keys(FEATURE_BITS).filter(
    (key) => !key.startsWith("RESERVED_") &&
      (!CREATION_FEATURES.has(key) || key === "ALARMAS_TAB_CREAR_VIEW" || key === "ALARMAS_TAB_CREAR_EDIT")
  ),

  // Operación diaria de recursos existentes, control y automatización.
  2: [
    "INICIO_VIEW", "INICIO_TAB_BIENVENIDA_VIEW", "INICIO_TAB_MIS_SENSORES_VIEW",
    "INICIO_TAB_MIS_ESTADISTICAS_VIEW",
    "ESTANQUES_VIEW", "ESTANQUES_EDIT", "ESTANQUES_TAB_EDITAR_VIEW", "ESTANQUES_TAB_EDITAR_EDIT",
    "DISPOSITIVOS_VIEW", "DISPOSITIVOS_EDIT", "DISPOSITIVOS_TAB_EDITAR_VIEW", "DISPOSITIVOS_TAB_EDITAR_EDIT",
    "SENSORES_VIEW", "SENSORES_EDIT", "SENSORES_TAB_EDITAR_VIEW", "SENSORES_TAB_EDITAR_EDIT",
    "EFECTORES_VIEW", "EFECTORES_EDIT", "EFECTORES_TAB_EDITAR_VIEW", "EFECTORES_TAB_EDITAR_EDIT",
    "ALARMAS_VIEW", "ALARMAS_EDIT", "ALARMAS_TAB_ADMIN_VIEW", "ALARMAS_TAB_ADMIN_EDIT",
    "ALARMAS_TAB_HISTORIAL_VIEW", "ALARMAS_TAB_HISTORIAL_EDIT",
    "AUTOMATIZACION_VIEW", "AUTOMATIZACION_EDIT",
    "AUTOMATIZACION_TAB_SENSORES_VIEW", "AUTOMATIZACION_TAB_SENSORES_EDIT",
    "AUTOMATIZACION_TAB_EFECTORES_VIEW", "AUTOMATIZACION_TAB_EFECTORES_EDIT",
    "REPORTERIA_VIEW", "ESTANQUES_TAB_LISTA_VIEW", "DISPOSITIVOS_TAB_LISTA_VIEW",
    "SENSORES_TAB_LISTA_VIEW", "EFECTORES_TAB_LISTA_VIEW",
  ],

  // Consulta estricta: Inicio y Reportería, sin edición.
  3: [
    "INICIO_VIEW", "INICIO_TAB_BIENVENIDA_VIEW", "INICIO_TAB_MIS_SENSORES_VIEW",
    "INICIO_TAB_MIS_ESTADISTICAS_VIEW", "ALARMAS_VIEW", "ALARMAS_TAB_ADMIN_VIEW",
    "ALARMAS_TAB_HISTORIAL_VIEW", "REPORTERIA_VIEW",
    "ESTANQUES_TAB_LISTA_VIEW", "DISPOSITIVOS_TAB_LISTA_VIEW",
    "SENSORES_TAB_LISTA_VIEW", "EFECTORES_TAB_LISTA_VIEW",
  ],
};

export const bitsetPredeterminadoPorRol = (rolId) => {
  const chars = Array(BITSET_LEN).fill("0");
  for (const key of ROLE_DEFAULT_FEATURES[Number(rolId)] || ["INICIO_VIEW"]) {
    const pos = FEATURE_BITS[key];
    if (Number.isInteger(pos) && pos >= 1 && pos <= BITSET_LEN) chars[pos - 1] = "1";
  }
  chars[FEATURE_BITS.INICIO_VIEW - 1] = "1";
  return forceFixedPermissions(chars.join(""));
};

// Accesos fijos para todas las cuentas y roles, incluidos los personalizados.
export const FIXED_PERMISSION_BITS = [1, 11, 87];
export const forceFixedPermissions = (value) => {
  const bits = String(value || "").padEnd(BITSET_LEN, "0").slice(0, BITSET_LEN).split("");
  FIXED_PERMISSION_BITS.forEach((position) => { bits[position - 1] = "1"; });
  return bits.join("");
};
